import styled from 'styled-components';

export const SearchInput = styled.div`
  position: relative;
  min-width: 324px;
`;
